import './GlobalStyles.css';

function DefaultStyles({ children }) {
    return (
        <>
            {children}
        </>
       
    );
}

export default DefaultStyles;